import { isPossiblePhoneNumber } from 'react-phone-number-input';
import dayjs from 'dayjs';

export const validatePhoneNumber = (phoneNumber) => {
    if(phoneNumber && !isPossiblePhoneNumber(phoneNumber)){
        return false
    }
    else{
        return true
    }
};

export const calculateAge = from_date => {
    const birthDate = dayjs(from_date);
    const age = dayjs().diff(birthDate, 'year');
    return age;
};